import Vue from 'vue'
import VueRouter from 'vue-router'
import ShopList from '../components/shops/shops-list.vue'
import SellerList from '../components/sellers/shops-sellers-list.vue'
import Monetization from '../components/monetization.vue'
import ShopGoodsList from '../components/goods/shops-goods-list.vue'
import Login from '../components/login.vue'
import Rating from '../components/rating.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: '/shoplist',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Login
  },
  {
    path: '/top',
    name: 'Rating',
    component: Rating
  },
  {
    path: '/shoplist',
    name: 'ShopList',
    component: ShopList
  },
  {
    path: '/sellerlist',
    name: 'SellerList',
    component: SellerList
  },
  {
    path: '/bonus',
    name: 'Monetization',
    component: Monetization
  },
  {
    path: '/goods',
    name: 'ShopGoodsList',
    component: ShopGoodsList
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
    if (to.name == 'Login') return next();
    let refresh = localStorage.getItem("refresh_token");
    if (refresh) {
      return next();
    } else return next({path: '/login'});
})

export default router
